<template>
   <div>
    <navbar :sid='sid' :pid="pid"></navbar>
    <mainmap ref='mainmap' :pid="pid" :sid="sid" :did="did"></mainmap>
    <videoplayer :sid="sid" :did="did"></videoplayer>
    <maptools :sid='sid'></maptools>
   </div>
</template>

<script>
// import interact from 'interactjs';
import { mapActions, mapState, mapMutations } from 'vuex';


import navbar from '@/components/nav.vue';
import maptools from '@/components/maptools.vue';
import mainmap from '@/components/map.vue';
import videoplayer from '@/components/videoplayer.vue';
import SubSection from '@/components/subsection.vue';

export default {
  data() {
    return {
    };
  },
  components: {
    navbar,
    maptools,
    mainmap,
    videoplayer,
    SubSection
  },
  created() {
    document.title="Skylark Drones Inspection Portal";
    // As of now comment categories is not attached to project and hence 
    // we need to retrieve it only once.
  },
  mounted() {
    this.triggerCommentCategoriesFetch();
    this.initData();
    this.$refs.mainmap.setMapViewBasedOnProjectData();
    this.$refs.mainmap.redrawLayers();
    this.setCurrentSid(this.sid);
    if (this.did) {
      this.setCurrentDid(this.did);
    }
  },
  destroyed() {
    // this.setCurrentProject({});
    this.clearProjectData();
    NProgress.done();
  },
  methods: {
    ...mapActions([
      'retrieveProjects',
      'retrievePositionJSON',
      'retrieveComments',
      'retrieveCommentCategories',
    ]),
    ...mapMutations([
      'clearProjectVideosLoaded',
      'clearProjectData',
      'setCurrentDid',
      'setCurrentSid',
      'addToProjectVideos',
      'addToProjectLayers',
      'addToProjectDsms',
      'addToProjectImages',
      'setCurrentProject',
      'setProjectDids',
    ]),

    triggerPositionJSONFetch() {
      // console.log('triggering fetch');
      this.retrievePositionJSON({data_id: this.did, setToCurrent: true});
    },

    triggerProjectsFetch() {
      this.retrieveProjects({pid: this.pid, sid: this.sid});
    },

    triggerCommentsFetch(did) {
      this.retrieveComments(did);
    },

    triggerCommentCategoriesFetch() {
      this.retrieveCommentCategories();
    },

    initData() {
      this.triggerProjectsFetch();
      this.retrievePositionJSON({data_id: this.did, setToCurrent: true});
      // this.triggerCommentsFetch();
    },
  },
  computed: {
    ...mapState([
      'currentProject',
      'currentSid',
      'currentDid',
    ]),
    sid: function() {
      return this.$route.query.sid;
    },
    pid: function() {
      return this.$route.query.pid;
    },
    did: function() {
      return this.$route.query.did;
    },
  },
  watch: {
    currentSid() {
      // NOTE: This is only called when we don't know did
      // get first did based on sid
      if (!this.currentProject.subsections) { return; }
      let did = null;
      Array.from(this.currentProject.subsections).forEach((subsection) => {
        if (Number(subsection.subsection_id) == Number(this.currentSid)) {
          Array.from(subsection.data).forEach((data) => {
            if (!did && data.video) {
              did = data.data_id;
            }
          })
        }
      })
      this.$router.push({
        name: 'VideoMode',
        query: {
          pid: this.pid,
          sid: this.currentSid,
          did: did,
        },
      })

    },
    currentDid() {
      // Get the correct sid based on did
      if (!this.currentProject.subsections) { return; }
      let sid = null;
      Array.from(this.currentProject.subsections).forEach((subsection) => {
        Array.from(subsection.data).forEach((data) => {
          if (Number(data.data_id) == Number(this.currentDid)) {
            sid = subsection.subsection_id;
          }
        })
      })
      this.$router.push({
        name: 'VideoMode',
        query: {
          pid: this.pid,
          sid: sid,
          did: this.currentDid,
        },
      })
    },
    sid() {
      this.initData();
    },
    did() {
      this.initData();
    },
    currentProject() {
      if (!this.currentProject.subsections) { return; }
      // NProgress.start();
      this.retrievePositionJSON({data_id: this.did, setToCurrent: true});
      let currentDid = null;
      let projectDids = {};
      Array.from(this.currentProject.subsections).forEach((subsection) => {
        Array.from(subsection.data).forEach((data) => {
          this.retrieveComments(data.data_id);
          if (data.video) {
            projectDids[Number(data.data_id)] = 'video';
            this.addToProjectVideos(Number(data.data_id));

            if (!currentDid && !this.did && Number(this.sid) == Number(subsection.subsection_id)) {
              currentDid = data.data_id;
              this.setCurrentDid(data.data_id);
            }
            this.retrievePositionJSON({data_id: data.data_id, setToCurrent: false});
          } else if (data.image) {
            this.addToProjectImages(data);
            projectDids[Number(data.data_id)] = 'image';
          } else if (data.layer.length) {
            // NOTE: Currently, we are assuming that all the layers are orthos
            // as layer type has not been stored in backend. Once that is resolved,
            // we will need to create projectOrthos, projectDSMs, projectDrawings
            // in store, and add to the appropriate list.
            if (data.layer_type == 'RGB') {
              this.addToProjectLayers(data);
            } else if (data.layer_type == 'DSM') {
              this.addToProjectDsms(data);
            }
            projectDids[Number(data.data_id)] = 'layer';
          }
        })
      })
      this.setProjectDids(projectDids);
    },
  }
};
</script>

<style lang="scss" scoped>

</style>

